import { InjectionToken } from '@angular/core';
import posthog from 'posthog-js';

/** The subset of the PostHog browser SDK used by AnalyticsService. */
export type PostHogClient = Pick<
  typeof posthog,
  'capture' | 'identify' | 'init' | 'reset'
>;

/** Injectable PostHog client; defaults to the real SDK singleton, overridable in tests. */
export const POSTHOG_CLIENT = new InjectionToken<PostHogClient>(
  'POSTHOG_CLIENT',
  {
    factory: () => posthog,
    providedIn: 'root',
  }
);
